export const schedulesFromDataBase = [
    {
        name: 'Healthy Week Plan',
        description: 'A balanced and nutritious plan for a healthy week.',
        number: 1,
        mealPlan: {
            monday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Grilled Chicken Salad',
                dinner: 'Baked Salmon with Asparagus',
            },
            tuesday: {
                breakfast1: 'Avocado Toast with Egg',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Quinoa and Veggie Bowl',
                dinner: 'Sweet Potato and Black Bean Tacos',
            },
            wednesday: {
                breakfast1: 'Banana and Almond Smoothie',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Stuffed Bell Peppers',
                dinner: 'Turkey and Spinach Wrap',
            },
            thursday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Chickpea Salad',
                dinner: 'Baked Salmon with Asparagus',
            },
            friday: {
                breakfast1: 'Avocado Toast with Egg',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Grilled Chicken Salad',
                dinner: 'Sweet Potato and Black Bean Tacos',
            },
            saturday: {
                breakfast1: 'Banana and Almond Smoothie',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Quinoa and Veggie Bowl',
                dinner: 'Stuffed Bell Peppers',
            },
            sunday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Turkey and Spinach Wrap',
                dinner: 'Grilled Chicken Salad',
            },
        },
    },
    {
        name: 'Vegetarian Delight',
        description: 'A vegetarian-focused meal plan for the week.',
        number: 2,
        mealPlan: {
            monday: {
                breakfast1: 'Banana and Almond Smoothie',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Quinoa and Veggie Bowl',
                dinner: 'Sweet Potato and Black Bean Tacos',
            },
            tuesday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Chickpea Salad',
                dinner: 'Stuffed Bell Peppers',
            },
            wednesday: {
                breakfast1: 'Avocado Toast with Egg',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Quinoa and Veggie Bowl',
                dinner: 'Sweet Potato and Black Bean Tacos',
            },
            thursday: {
                breakfast1: 'Banana and Almond Smoothie',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Chickpea Salad',
                dinner: 'Stuffed Bell Peppers',
            },
            friday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Quinoa and Veggie Bowl',
                dinner: 'Sweet Potato and Black Bean Tacos',
            },
            saturday: {
                breakfast1: 'Banana and Almond Smoothie',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Quinoa and Veggie Bowl',
                dinner: 'Stuffed Bell Peppers',
            },
            sunday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Chickpea Salad',
                dinner: 'Stuffed Bell Peppers',
            },
        },
    },
    {
        name: 'High Protein Plan',
        description:
            'A meal plan focused on protein-rich dishes for active individuals.',
        number: 3,
        mealPlan: {
            monday: {
                breakfast1: 'Avocado Toast with Egg',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Grilled Chicken Salad',
                dinner: 'Baked Salmon with Asparagus',
            },
            tuesday: {
                breakfast1: 'Banana and Almond Smoothie',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Turkey and Spinach Wrap',
                dinner: 'Grilled Chicken Salad',
            },
            wednesday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Stuffed Bell Peppers',
                dinner: 'Baked Salmon with Asparagus',
            },
            thursday: {
                breakfast1: 'Avocado Toast with Egg',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Grilled Chicken Salad',
                dinner: 'Turkey and Spinach Wrap',
            },
            friday: {
                breakfast1: 'Banana and Almond Smoothie',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Chickpea Salad',
                dinner: 'Grilled Chicken Salad',
            },
            saturday: {
                breakfast1: 'Oatmeal with Berries',
                breakfast2: 'Greek Yogurt Parfait',
                lunch: 'Turkey and Spinach Wrap',
                dinner: 'Baked Salmon with Asparagus',
            },
            sunday: {
                breakfast1: 'Avocado Toast with Egg',
                breakfast2: 'Apple Slices with Peanut Butter',
                lunch: 'Grilled Chicken Salad',
                dinner: 'Stuffed Bell Peppers',
            },
        },
    },
];
